import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { toast } from 'sonner';
import { errMsg } from '../components/diagnostico/errMsg.js';
import MainLayout from '../components/Layout/MainLayout.js';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/card.jsx';
import { Button } from '../components/ui/button.jsx';
import { ClipboardList, ArrowLeft } from 'lucide-react';
import DiagnosticForm from '../components/diagnostico/DiagnosticForm.js';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const auth = () => ({ headers: { Authorization: `Bearer ${localStorage.getItem('token')}` } });

const ResponderDiagnostico = () => {
  const { diagnosticId } = useParams();
  const navigate = useNavigate();
  const userRole = localStorage.getItem('userRole') || 'respondent';
  const [diag, setDiag] = useState(null);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    axios.get(`${API}/diagnostics/${diagnosticId}`, auth())
      .then(r => setDiag(r.data))
      .catch(err => {
        toast.error(errMsg(err, 'Erro ao carregar diagnóstico'));
        navigate('/diagnosticos');
      });
  }, [diagnosticId, navigate]);

  const submit = async (answers) => {
    setSaving(true);
    try {
      await axios.post(`${API}/diagnostics/${diagnosticId}/responses`, { answers }, auth());
      toast.success('Respostas salvas com sucesso!');
      navigate('/diagnosticos');
    } catch (err) {
      toast.error(errMsg(err, 'Erro ao enviar'));
    } finally { setSaving(false); }
  };

  if (!diag) return <MainLayout title="Diagnóstico" userRole={userRole}><p className="text-sm text-slate-400 p-6">Carregando...</p></MainLayout>;

  return (
    <MainLayout title="Responder Diagnóstico" userRole={userRole}>
      <div className="space-y-5 max-w-3xl mx-auto" data-testid="responder-diag-page">
        <Button variant="outline" size="sm" onClick={() => navigate('/diagnosticos')} data-testid="back-btn">
          <ArrowLeft className="w-4 h-4 mr-1" /> Voltar
        </Button>
        <Card>
          <CardHeader>
            <CardTitle className="text-base flex items-center gap-2"><ClipboardList className="w-4 h-4 text-blue-600" /> {diag.nome}</CardTitle>
            {diag.descricao && <p className="text-sm text-slate-500 mt-1">{diag.descricao}</p>}
          </CardHeader>
          <CardContent>
            <DiagnosticForm
              questions={diag.questions}
              initialAnswers={diag.my_answers}
              locked={diag.locked}
              hasPrevious={(diag.my_answers || []).length > 0}
              saving={saving}
              onSubmit={submit}
            />
          </CardContent>
        </Card>
      </div>
    </MainLayout>
  );
};

export default ResponderDiagnostico;
